module.exports = __webpack_public_path__ + "media/images/home-banners/horse-60153_1920-665caef0b58fc4a8d57c6587e7c92bf9.jpg";